import React from 'react'
import { Sidebar } from 'primereact/sidebar';
import classes from './Sidebar.module.css';
import {Link, useLocation} from 'react-router-dom'


const SidebarComponent = ({visible,handle,active}) => {

  const {pathname} = useLocation()
  console.log(pathname)

  return (
    <Sidebar visible={visible} position="left" onHide={handle } className={classes.sidebar}>
    <div>
      <p className={classes.title}>Video Categories</p>
      <ul className={classes.list}>
      <li className={`text-white p-2 hover:decoration-solid  ${active == undefined && 'text-yellow-500 underline'}`}>
                  <Link to="/" className='p-2 hover:underline hover:text-yellow-500'>HOME</Link>
                </li>
                <li className={`text-white p-2 hover:decoration-solid  ${active == 'Sports' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Sports" className='p-2 hover:underline hover:text-yellow-500'>SPORTIFS</Link>
                </li>
                <li  className={`text-white p-2  ${active == 'Funny' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Funny" className='p-2 hover:underline hover:text-yellow-500' >FUNNY</Link>
                </li>
                <li  className={`text-white p-2 ${active == 'Action' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Action" className='p-2 hover:underline hover:text-yellow-500'>D'ACTION</Link>
                </li>
                <li  className={`text-white p-2  ${active == 'Adventure' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Adventure" className='p-2 hover:underline hover:text-yellow-500'>D'AVENTURE</Link>
                </li>
                <li className={`text-white p-2  ${active == 'Racing' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Racing" className='p-2 hover:underline hover:text-yellow-500'>RACING</Link>
                </li>
                <li className={`text-white p-2 hover:decoration-solid hover:underline hover:text-yellow-500 ${active == 'Kids' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Kids" className='p-2 hover:underline hover:text-yellow-500'>KIDS</Link>
                </li>
                <li className={`text-white p-2  ${active == 'Arcade' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Arcade" className='p-2 hover:underline hover:text-yellow-500'>ARCADE</Link>
                </li>
                <li className={`text-white p-2  ${active == 'Puzzle' && 'text-yellow-500 underline'}`}>
                  <Link to="/Category/Puzzle" className='p-2 hover:underline hover:text-yellow-500'>PUZZLE</Link>
                </li>
       
      </ul>
    </div>
    </Sidebar>
  )
}

export default SidebarComponent
